import React, { useEffect, useState } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';

// components
import Loader from '../../components/Loader/Loader';
import LeadBankOffers from '../../components/CreditApplications/LeadBankOffers';
import LeadCreditApplicationDetails from '../../components/CreditApplications/LeadCreditApplicationDetails';
import Status from '../../components/Status';
import tableStyles from '../../components/Table/table.module.css';
import arrow from '../../assets/arrow.svg';
import leadDealStatusColor from '../../utils/leadDealStatusColor';
import leadBankSummary from '../../utils/leadBankSummary';
import { colors } from '../../constants/colors';
import { BANK_CREDIT_ACCEPTED } from '../../constants/bankCreditStatuses';

// api
import getLeadCard from '../../api/leads/getLeadCard';
import formatDate from '../../utils/formatDate';
import formatNumber from '../../utils/formatNumber';
import fixDateTimezone from '../../utils/fixDateTimezone';

const formatRemaining = (ms) => {
  if (ms <= 0) return null;
  const totalMinutes = Math.floor(ms / 60000);
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  return hours > 0 ? `${hours} Ñ ${minutes} Ð¼Ð¸Ð½` : `${minutes} Ð¼Ð¸Ð½`;
};

// ÐÐ°ÑÑ ÑÐ´ÐµÐ»Ð¾Ðº Ð¿ÑÐ¸ÑÐ¾Ð´ÑÑ Ð² UTC; Ð² ÑÐ¿Ð¸ÑÐºÐµ Ð»Ð¸Ð´Ð¾Ð² Ð¾Ð½Ð¸ ÑÐ¶Ðµ Ð¿Ð¾ÐºÐ°Ð·ÑÐ²Ð°ÑÑÑÑ ÑÐµÑÐµÐ· ÑÑÑ Ð¿Ð°ÑÑ
// ÑÑÐ¸Ð»Ð¸Ñ, Ð° ÑÑÑ Ð´Ð°ÑÐ°, ÑÐ½ÑÑÐ°Ñ Ð½Ð° Ð³Ð¾Ð»Ð¾Ð¼ new Date(), Ñ Ð²ÐµÑÐµÑÐ½Ð¸Ñ ÑÐ´ÐµÐ»Ð¾Ðº ÑÐµÐ·Ð¶Ð°Ð»Ð° Ð½Ð° Ð´ÐµÐ½Ñ.
const dealDate = (value) => (value ? formatDate(fixDateTimezone(value)) : '');

const TtlCountdown = ({ expiresAt }) => {
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    const interval = setInterval(() => setNow(Date.now()), 30000);
    return () => clearInterval(interval);
  }, []);

  if (!expiresAt) return null;
  const remaining = formatRemaining(new Date(expiresAt).getTime() - now);
  if (!remaining) return null;

  return (
    <div style={{ background: '#FFF6E5', border: '1px solid #F5C56B', borderRadius: 8, padding: '10px 16px', marginBottom: 20 }}>
      ÐÐ°Ð½ÐºÐ¸ ÐµÑÑ Ð½Ðµ Ð¾ÑÐ²ÐµÑÐ¸Ð»Ð¸ â Ð¾ÑÑÐ°Ð»Ð¾ÑÑ {remaining}.
    </div>
  );
};

const styles = {
  card: { padding: 24, border: '1px solid #E7E7ED', borderRadius: 8, background: '#FFFFFF', marginTop: 20 },
  cardTitle: { fontWeight: 600, fontSize: 15, margin: '0 0 16px' },
  scroll: { overflowX: 'auto' },
  nowrap: { whiteSpace: 'nowrap', wordBreak: 'normal' },
  current: { marginLeft: 8, color: '#6A6A6A', fontSize: 12, fontWeight: 400 },
  sub: { color: '#6A6A6A', fontSize: 12, lineHeight: '16px' },
  open: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
    // ÐÐµÐ¶ÐµÐ²ÑÐ¹ Ð¿Ð¾ Ð±ÐµÐ»Ð¾Ð¼Ñ â ÐºÐ¾Ð½ÑÑÐ°ÑÑ ~2:1, Ð´Ð»Ñ Ð´ÐµÐ¹ÑÑÐ²Ð¸Ð¹ Ð±ÐµÑÑÐ¼ ÑÑÐ¼Ð½ÑÐ¹ ÑÐ²ÐµÑ Ð±ÑÐµÐ½Ð´Ð°
    color: 'var(--brand-dark)',
    fontWeight: 600,
    textDecoration: 'underline',
    textUnderlineOffset: 3,
    whiteSpace: 'nowrap',
  },
  // ÐÐ±Ð»Ð°ÑÑÑ ÐºÐ»Ð¸ÐºÐ° 32Ã32: ÑÑÑÐµÐ»ÐºÐ° Ð² 8px Ð³Ð»Ð¸ÑÐµ Ð¿Ð¾Ð¿Ð°Ð´Ð°Ð»Ð° Ð¼ÑÑÑÑ ÑÐ¾Ð»ÑÐºÐ¾ Ñ ÑÑÐµÑÑÐµÐ¹ Ð¿Ð¾Ð¿ÑÑÐºÐ¸
  toggle: { display: 'flex', alignItems: 'center', justifyContent: 'center', width: 32, height: 32, borderRadius: 4 },
  chevron: { display: 'block', transition: 'transform 0.15s ease-out' },
  details: { padding: '8px 24px 24px', background: '#FFFFFF' },
  detailsTitle: { fontWeight: 600, fontSize: 14, margin: '16px 0 12px' },
  muted: { color: '#8B8B8B', fontSize: 14 },
  pastToggle: {
    marginTop: 12,
    padding: 0,
    color: 'var(--brand-dark)',
    textDecoration: 'underline',
    textUnderlineOffset: 3,
    fontSize: 14,
    fontWeight: 600,
    cursor: 'pointer',
    background: 'none',
    border: 'none',
  },
};

// Â«ÐµÑÑ 1 ÑÐ´ÐµÐ»ÐºÑÂ», Â«ÐµÑÑ 2 ÑÐ´ÐµÐ»ÐºÐ¸Â», Â«ÐµÑÑ 5 ÑÐ´ÐµÐ»Ð¾ÐºÂ»
const pastLabel = (n) => {
  const last = n % 10;
  if (n % 100 >= 11 && n % 100 <= 14) return 'ÑÐ´ÐµÐ»Ð¾Ðº';
  if (last === 1) return 'ÑÐ´ÐµÐ»ÐºÑ';
  if (last >= 2 && last <= 4) return 'ÑÐ´ÐµÐ»ÐºÐ¸';
  return 'ÑÐ´ÐµÐ»Ð¾Ðº';
};

const DealRow = ({ deal, current, status, expanded, onToggle, onOpen }) => {
  const car = deal.car;
  const banks = leadBankSummary(deal.banks);
  return (
    <tr onClick={onOpen} style={current ? { backgroundColor: colors.rowYellowBG } : undefined}>
      <td style={{ width: 40, paddingLeft: 4 }} onClick={(e) => e.stopPropagation()}>
        {current && (
          <button
            type="button"
            style={styles.toggle}
            onClick={onToggle}
            aria-expanded={expanded}
            aria-label={expanded ? 'Ð¡Ð²ÐµÑÐ½ÑÑÑ Ð·Ð°ÑÐ²ÐºÑ Ð¸ Ð±Ð°Ð½ÐºÐ¸' : 'ÐÐ¾ÐºÐ°Ð·Ð°ÑÑ Ð·Ð°ÑÐ²ÐºÑ Ð¸ Ð±Ð°Ð½ÐºÐ¸'}
          >
            <img src={arrow} alt="" style={{ ...styles.chevron, transform: expanded ? 'none' : 'rotate(-90deg)' }} />
          </button>
        )}
      </td>
      <td style={styles.nowrap}>
        <b>â{deal.id}</b>
        {current && <span style={styles.current}>ÑÐµÐºÑÑÐ°Ñ</span>}
      </td>
      <td style={styles.nowrap}>{dealDate(deal.createdAt)}</td>
      <td>
        {car ? (
          <>
            <div>{[car.mark, car.model].filter(Boolean).join(' ')}</div>
            <div style={styles.sub}>
              {[car.complectation, car.price ? `${formatNumber(car.price)} â¸` : null].filter(Boolean).join(' Â· ')}
            </div>
          </>
        ) : (
          'â'
        )}
      </td>
      <td style={{ minWidth: 190, maxWidth: 260 }}>
        {status.title && <Status status={status.title} color={leadDealStatusColor(status)} />}
      </td>
      <td>
        {banks.length ? (
          banks.map((part, i) => (
            <span key={part.text} style={{ color: part.color }}>
              {i > 0 && <span style={{ color: '#B4B4B4' }}> Â· </span>}
              {part.text}
            </span>
          ))
        ) : (
          <span style={styles.sub}>Ð·Ð°ÑÐ²Ð¾Ðº Ð½ÐµÑ</span>
        )}
      </td>
      <td onClick={(e) => e.stopPropagation()} style={{ paddingRight: 12, textAlign: 'right' }}>
        <Link to={`/deals/deal/${deal.id}/main-info`} style={styles.open}>
          ÐÑÐºÑÑÑÑ
          <img src={arrow} alt="" style={{ transform: 'rotate(-90deg)' }} />
        </Link>
      </td>
    </tr>
  );
};

/**
 * Ð¢Ð°Ð± Â«Ð¡Ð´ÐµÐ»ÐºÐ¸Â» Ð½Ð° ÐºÐ°ÑÑÐ¾ÑÐºÐµ Ð»Ð¸Ð´Ð°: Ð²ÑÐµ ÑÐ´ÐµÐ»ÐºÐ¸ Ð»Ð¸Ð´Ð° ÑÐ°Ð±Ð»Ð¸ÑÐµÐ¹, ÐºÐ°Ðº Ð² ÑÐ°Ð·Ð´ÐµÐ»Ðµ Â«Ð¡Ð´ÐµÐ»ÐºÐ¸Â».
 * Ð£ Ð»Ð¸Ð´Ð° Ð¸Ñ Ð±ÑÐ²Ð°ÐµÑ Ð½ÐµÑÐºÐ¾Ð»ÑÐºÐ¾ (ÑÑÐ°ÑÐ°Ñ Ð¿ÑÐ¾ÑÑÐ¾ÑÐµÐ½Ð° Ð¿Ð¾ TTL, Ð·Ð°Ð²ÐµÐ»Ð¸ Ð½Ð¾Ð²ÑÑ), Ð¿Ð¾ÑÑÐ¾Ð¼Ñ Ð² ÑÑÑÐ¾ÐºÐµ
 * Ð½Ðµ ÑÐ¾Ð»ÑÐºÐ¾ Ð½Ð¾Ð¼ÐµÑ, Ð½Ð¾ Ð¸ Ð¼Ð°ÑÐ¸Ð½Ð°, Ð´Ð°ÑÐ° Ð¸ Ð¾ÑÐ²ÐµÑÑ Ð±Ð°Ð½ÐºÐ¾Ð² â ÑÑÐ¾Ð±Ñ Ð±ÑÐ»Ð¾ Ð¿Ð¾Ð½ÑÑÐ½Ð¾, ÐºÐ°ÐºÐ°Ñ
 * ÑÐ´ÐµÐ»ÐºÐ° ÐºÐ°ÐºÐ°Ñ. Ð¢ÐµÐºÑÑÐ°Ñ (Ð¿Ð¾ÑÐ»ÐµÐ´Ð½ÑÑ) Ð²ÑÐ´ÐµÐ»ÐµÐ½Ð°; Ð¿Ð¾ ÑÑÑÐµÐ»ÐºÐµ ÑÐ°ÑÐºÑÑÐ²Ð°ÑÑÑÑ Ð´Ð°Ð½Ð½ÑÐµ Ð·Ð°ÑÐ²ÐºÐ¸ Ð¸
 * Ð±Ð°Ð½ÐºÐ¸ Ñ Ð²ÑÐ±Ð¾ÑÐ¾Ð¼ Ð¿ÑÐµÐ´Ð»Ð¾Ð¶ÐµÐ½Ð¸Ñ. ÐÐ»Ð¸Ðº Ð¿Ð¾ ÑÑÑÐ¾ÐºÐµ Ð¾ÑÐºÑÑÐ²Ð°ÐµÑ ÑÐ´ÐµÐ»ÐºÑ.
 */
const LeadDealInfo = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [lead, setLead] = useState();
  const [loading, setLoading] = useState(true);
  const [expanded, setExpanded] = useState(false);
  const [showPast, setShowPast] = useState(false);

  const deals = lead?.deals || [];
  const activeDeal = deals[0];
  // ÐÑÐ¾ÑÐ»ÑÐµ ÑÐ´ÐµÐ»ÐºÐ¸ â Ð¸ÑÑÐ¾ÑÐ¸Ñ (Ð±ÑÐ¾ÑÐ¸Ð»Ð¸ Ð°Ð½ÐºÐµÑÑ, Ð½Ð°ÑÐ°Ð»Ð¸ Ð·Ð°Ð½Ð¾Ð²Ð¾, Ð¿ÑÐ¾ÑÑÐ¾ÑÐ¸Ð»Ð¸): Ð¿Ð¾ ÑÐ¼Ð¾Ð»ÑÐ°Ð½Ð¸Ñ ÑÐ²ÑÑÐ½ÑÑÑ.
  const pastCount = deals.length - 1;
  const visibleDeals = showPast ? deals : deals.slice(0, 1);

  const init = () => {
    getLeadCard({ id })
      .then((res) => setLead(res.data))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    init();
  }, [id]);

  if (loading) return <Loader />;

  if (!activeDeal) {
    return (
      <div style={styles.card}>
        <p style={styles.muted}>ÐÐ¾ ÑÑÐ¾Ð¼Ñ Ð»Ð¸Ð´Ñ ÐµÑÑ Ð½ÐµÑ ÑÐ´ÐµÐ»ÐºÐ¸ â Ð·Ð°ÑÐ²ÐºÐ¸ Ð² Ð±Ð°Ð½ÐºÐ¸ Ð½Ðµ Ð¾ÑÐ¿ÑÐ°Ð²Ð»ÑÐ»Ð¸ÑÑ.</p>
      </div>
    );
  }

  // ÐÐµÐ¹Ð´Ð¶ ÑÐµÐºÑÑÐµÐ¹ ÑÐ´ÐµÐ»ÐºÐ¸ â Ð¿Ð¾ ÑÐ°ÐºÑÑ Ð¾Ð´Ð¾Ð±ÑÐµÐ½Ð¸Ñ Ð¸Ð· Ð·Ð°ÑÐ²Ð¾Ðº (lead.dealStatus), ÐºÐ°Ðº Ð² ÑÐ¿Ð¸ÑÐºÐµ Ð»Ð¸Ð´Ð¾Ð².
  const statusOf = (deal, index) =>
    index === 0 && lead.dealStatus
      ? lead.dealStatus
      : { id: deal.statusId, title: deal.status?.title, bankApproved: !!deal.banks?.[BANK_CREDIT_ACCEPTED] };

  return (
    <div style={styles.card}>
      {activeDeal.ttlExpiresAt && <TtlCountdown expiresAt={activeDeal.ttlExpiresAt} />}

      <p style={styles.cardTitle}>Ð¡Ð´ÐµÐ»ÐºÐ¸ Ð»Ð¸Ð´Ð°</p>
      <div style={styles.scroll}>
        <table className={tableStyles.table} style={{ minWidth: 820 }}>
          <thead>
            <tr>
              <th style={{ width: 40 }} />
              <th>Ð¡Ð´ÐµÐ»ÐºÐ°</th>
              <th>ÐÐ°ÑÐ°</th>
              <th>ÐÐ²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ñ</th>
              <th>Ð­ÑÐ°Ð¿</th>
              <th>ÐÐ°Ð½ÐºÐ¸</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {visibleDeals.map((deal, index) => (
              <React.Fragment key={deal.id}>
                <DealRow
                  deal={deal}
                  current={index === 0}
                  status={statusOf(deal, index)}
                  expanded={expanded}
                  onToggle={() => setExpanded(!expanded)}
                  onOpen={() => navigate(`/deals/deal/${deal.id}/main-info`)}
                />
                {index === 0 && expanded && (
                  <tr style={{ cursor: 'default' }}>
                    <td colSpan={7} style={{ padding: 0 }}>
                      <div style={styles.details}>
                        <p style={styles.detailsTitle}>ÐÐ°Ð½Ð½ÑÐµ Ð·Ð°ÑÐ²ÐºÐ¸</p>
                        <LeadCreditApplicationDetails chunkId={activeDeal.chunkId} />
                        <p style={{ ...styles.detailsTitle, marginTop: 28 }}>ÐÐ°Ð½ÐºÐ¸</p>
                        <LeadBankOffers
                          chunkId={activeDeal.chunkId}
                          dealStatusId={activeDeal.statusId}
                          onOfferSelected={init}
                        />
                      </div>
                    </td>
                  </tr>
                )}
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>
      {pastCount > 0 && (
        <button type="button" style={styles.pastToggle} onClick={() => setShowPast(!showPast)}>
          {showPast ? 'Ð¡ÐºÑÑÑÑ Ð¿ÑÐ¾ÑÐ»ÑÐµ ÑÐ´ÐµÐ»ÐºÐ¸' : `ÐÐ¾ÐºÐ°Ð·Ð°ÑÑ ÐµÑÑ ${pastCount} ${pastLabel(pastCount)}`}
        </button>
      )}
    </div>
  );
};

export default LeadDealInfo;
